import { API_URL } from 'src/config/environment'
import apiCreator from '../api-creator'

type GetPresignedS3UploadLinkResponse = {
  presigned_url: string;
}

export async function getPresignedS3UploadLink(
  filename: string,
  abortSignal: AbortSignal,
): Promise<GetPresignedS3UploadLinkResponse> {
  return apiCreator
    .get<GetPresignedS3UploadLinkResponse>(
      `${API_URL.ANALOGUE}/upload/get-presigned-s3-url`,
      {
        params: {
          file_name: filename,
        },
        signal: abortSignal,
      },
    )
    .then(({ data }) => data)
}
